export default __webpack_public_path__ + "static/media/PalCompiler.66159fad.jpg";